module.exports = __webpack_public_path__ + "img/help-section-image04.b7fd768f.png";